<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="5" v-if="activeStep == 1">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-module-titlebar justify-center">Asignación de accesorios a personal</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    class="ui-form-field search-input"
                    v-model="busquedaPersonal.CUIP"
                    placeholder="Buscar personal"
                    rounded
                    filled
                    background-color="transparent"
                    color="secondary"
                    :disabled="loadingBusqueda"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <TextButton
                    rounded
                    block
                    large
                    color="secondary"
                    class="ui-module-btn-solid"
                    @click="triggerSearchPersonal()"
                    :disabled="loadingBusqueda || loading"
                    :loading="loadingBusqueda"
                  >
                    Buscar <v-icon class="ml-2">mdi-magnify</v-icon>
                  </TextButton>
                </v-col>
                <v-col cols="12">
                  <v-virtual-scroll :items="personal" item-height="98" height="300">
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item.idPersonal" link @click="setPersonal(item)">
                        <template v-slot:default="{ item }">
                          <v-list-item-avatar size="80">
                            <v-img :src="item.foto" v-if="item.foto !== ''"></v-img>
                            <v-icon size="48" v-else>mdi-account</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <div class="text-subtitle-2 font-weight-bold">{{ getFullName(item) }}</div>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <div v-if="item.CUIP.length > 0">{{ item.CUIP }}</div>
                              <div v-else>CUIP no asignado</div>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle> Estatus: {{ item.CatEstatus.title }} </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              Vigencia C3:
                              {{ item.vigenciaEvaluacionC3 === '' ? 'No registrado' : item.vigenciaEvaluacionC3 }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="activeStep == 2">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-module-titlebar">Asignación de items a personal</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col>
                  <v-text-field
                    class="ui-form-field"
                    v-model="asignacionItems.fechaSolicitud"
                    v-mask="'##/##/####'"
                    label="Fecha de solicitud"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    :rules="dateRules"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="ui-form-field"
                    v-model="asignacionItems.fechaAsignacion"
                    v-mask="'##/##/####'"
                    label="Fecha de asignación"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    :rules="dateRules"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="ui-form-field"
                    label="Folio de resguardo"
                    v-model="asignacionItems.folioResguardo"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-file-input
                    class="ui-form-field"
                    label="Evidencia"
                    v-model="asignacionItems.file"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        class="ui-form-field"
                        label="Tipo de item"
                        v-model="selectedTipoItem"
                        :items="tipoItem"
                        item-value="id"
                        item-text="title"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="transparent"
                      >
                      </v-select>
                      <v-autocomplete
                        class="ui-form-field"
                        v-model="selectedItems"
                        label="Items"
                        :items="filteredAccesorios"
                        background-color="transparent"
                        color="secondary"
                        rounded
                        filled
                        dense
                        :clearable="false"
                        multiple
                        hide-selected
                        return-object
                        item-text="CatItem.item"
                        item-value="idAccesorio"
                      >
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item link v-on="on" v-bind="attrs">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.CatItem.item }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.numero }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                      <v-textarea
                        class="ui-form-field"
                        label="Observaciones"
                        v-model="asignacionItems.observaciones"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="transparent"
                        no-resize
                        rows="4"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="selectedItems"
                    class="transparent ui-module-table"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.numero`]="{ index }">
                      <v-text-field
                        class="ui-form-field"
                        rounded
                        filled
                        dense
                        readonly
                        label="Numero"
                        v-model="selectedItems[index].numero"
                        color="secondary"
                        background-color="transparent"
                      ></v-text-field>
                    </template>
                    <template v-slot:[`item.fechaFabricacion`]="{ index }">
                      <v-menu
                        v-model="menuFechaFabricacion[index]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        disabled
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="ui-form-field"
                            :value="selectedItems[index].fechaFabricacion"
                            label="Fecha de fabricación"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="transparent"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedItems[index].fechaFabricacion"
                          @input="menuFechaFabricacion[index] = false"
                        ></v-date-picker>
                      </v-menu>
                    </template>
                    <template v-slot:[`item.aniosVigencia`]="{ index }">
                      <v-menu
                        v-model="menuAniosVigencia[index]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        disabled
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="ui-form-field"
                            :value="selectedItems[index].aniosVigencia"
                            label="Fecha de emisión"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="transparent"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedItems[index].aniosVigencia"
                          @input="menuAniosVigencia[index] = false"
                        ></v-date-picker>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              color="secondary"
              class="ui-module-btn-solid"
              @click="triggerSaveAsignacion()"
              :disabled="loading"
              :loading="loading"
            >
              Registrar asignación de items</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  beforeRouteLeave(to, from, next) {
    this.RESET_BUSQUEDA_PERSONAL()
    next()
  },

  data() {
    return {
      activeStep: 1,
      menuFechaSolicitud: false,
      menuFechaAsignacion: false,
      menuFechaFabricacion: [],
      menuAniosVigencia: [],
      loading: false,

      selectedTipoItem: null,

      asignacionItems: {
        fk_idPersonal: null,
        fechaSolicitud: '',
        fechaAsignacion: '',
        observaciones: '',
        evidencia: '',
        folioResguardo: '',
        itemAsignado: [],
        file: null,
      },

      headers: [
        { text: 'Tipo de item', value: 'CatItem.item' },
        { text: 'Número', value: 'numero' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion' },
        { text: 'Vigencia', value: 'aniosVigencia' },
      ],

      selectedItems: [],

      busquedaPersonal: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        curp: '',
        CUIP: '',
      },

      loadingBusqueda: false,

      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    ...mapGetters('tipoItemArmeria', {
      tipoItem: 'getTipoItem',
    }),

    ...mapGetters('accesorio', {
      accesorios: 'getAccesorios',
    }),

    filteredAccesorios() {
      if (this.accesorios.length > 0) {
        var filtered_accesorios_activos = this.accesorios.filter((accesorio) => {
          return accesorio.fk_idCatEstatus == 2
        })

        return filtered_accesorios_activos.filter((accesorio) => {
          return accesorio.CatItem.fk_idCatTipoItem == this.selectedTipoItem
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('asignacionItem', ['saveAsignacionItem']),
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSaveAsignacion() {
      this.loading = true

      this.selectedItems.forEach((item) => {
        this.asignacionItems.itemAsignado.push({
          fk_idAccesorio: item.idAccesorio,
        })
      })

      await this.saveAsignacionItem({
        fk_idPersonal: this.asignacionItems.fk_idPersonal,
        fechaSolicitud: this.asignacionItems.fechaSolicitud,
        fechaAsignacion: this.asignacionItems.fechaAsignacion,
        observaciones: this.asignacionItems.observaciones,
        evidencia: this.asignacionItems.file.name,
        folioResguardo: this.asignacionItems.folioResguardo,
        itemAsignado: this.asignacionItems.itemAsignado,
        file: this.asignacionItems.file,
      })

      this.loading = false
      this.RESET_BUSQUEDA_PERSONAL()
      this.$router.push('/armeria/inventario_items')
    },

    buscaPersonal() {
      return new Promise(async () => {
        setTimeout(await this.searchPersonal(this.busquedaPersonal), 200)
        this.loadingBusqueda = false
      })
    },

    triggerSearchPersonal() {
      this.loadingBusqueda = true
      if (this.busquedaPersonal.CUIP !== '') {
        this.buscaPersonal()
      } else {
        this.loadingBusqueda = false
        this.RESET_BUSQUEDA_PERSONAL()
      }
    },

    setPersonal(personal) {
      this.asignacionItems.fk_idPersonal = personal.idPersonal

      this.activeStep++
    },
  },
}
</script>

<style scoped>
/* Campos de entrada */
::v-deep .ui-form-field .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  transition: all 0.3s ease;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .v-file-input__text,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .ui-form-field .mdi-calendar {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Lista de items */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  transition: all 0.3s ease;
  background: rgba(18, 18, 18, 0.3) !important;
  border: 1px solid rgba(108, 92, 231, 0.1);
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.2) !important;
  border-color: rgba(108, 92, 231, 0.3);
  transform: translateX(4px);
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: #e0e0e0 !important;
}

/* Virtual scroll */
::v-deep .v-virtual-scroll {
  background: transparent !important;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(108, 92, 231, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-avatar {
  border-color: rgba(108, 92, 231, 0.6);
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.4);
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

.text-caption,
.text-subtitle-1,
.text-subtitle-2 {
  color: #e0e0e0 !important;
}

/* Menu del select */
::v-deep .v-menu__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

/* Date picker */
::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-header {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-date-picker-header .v-btn {
  color: #a29bfe !important;
}

::v-deep .v-date-picker-table .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table .v-btn:hover {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-date-picker-table .v-btn--active {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.4);
}

::v-deep .v-date-picker-table__current {
  border-color: #6c5ce7 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
